import { useMediaQuery, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Chip from '@rentspree/component-2023.components.atoms.chip'
import Typography from '@rentspree/component-2023.components.atoms.typography'
import { forwardRef } from 'react'

import styles from './index.module.scss'

interface AmenitiesProps {
  inUnit: string[]
  shared: string[]
  parking: string[]
}

const Amenities = forwardRef<HTMLDivElement, AmenitiesProps>(({ inUnit, shared, parking }, ref) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  if (inUnit.length === 0 && shared.length === 0 && parking.length === 0) {
    return null
  }

  return (
    <Box className={styles.amenitiesContainer} id="amenities" ref={ref}>
      <Typography variant={isMobile ? 'title-medium' : 'h3'} fontSize={isMobile ? 24 : 32}>
        Amenities
      </Typography>
      {inUnit.length > 0 && (
        <Box className={styles.amenitiesSectionContainer}>
          <Typography className={styles.bold} variant={isMobile ? 'body-large' : 'title-medium'}>
            In-unit
          </Typography>
          <Box className={styles.amenitiesChipContainer}>
            {inUnit.map((item) => (
              <Chip key={item} color="primary" label={item} />
            ))}
          </Box>
        </Box>
      )}
      {shared.length > 0 && (
        <Box className={styles.amenitiesSectionContainer}>
          <Typography className={styles.bold} variant={isMobile ? 'body-large' : 'title-medium'}>
            Shared
          </Typography>
          <Box className={styles.amenitiesChipContainer}>
            {shared.map((item) => (
              <Chip key={item} color="primary" label={item} />
            ))}
          </Box>
        </Box>
      )}
      {parking.length > 0 && (
        <Box className={styles.amenitiesSectionContainer}>
          <Typography className={styles.bold} variant={isMobile ? 'body-large' : 'title-medium'}>
            Parking
          </Typography>
          <Box className={styles.amenitiesChipContainer}>
            {parking.map((item) => (
              <Chip key={item} color="primary" label={item} />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  )
})

Amenities.displayName = 'Amenities'

export default Amenities
